import { render, staticRenderFns } from "./form-bmi.vue?vue&type=template&id=50208efe&scoped=true"
import script from "./form-bmi.vue?vue&type=script&lang=js"
export * from "./form-bmi.vue?vue&type=script&lang=js"
import style0 from "./form-bmi.vue?vue&type=style&index=0&id=50208efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50208efe",
  null
  
)

export default component.exports